var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 3V22C15.75 22.414 15.414 22.75 15 22.75H3C2.536 22.75 2.091 22.566 1.763 22.237C1.434 21.909 1.25 21.464 1.25 21V3C1.25 2.536 1.434 2.091 1.763 1.763C2.091 1.434 2.536 1.25 3 1.25H14C14.464 1.25 14.909 1.434 15.237 1.763C15.566 2.091 15.75 2.536 15.75 3ZM14.25 3C14.25 2.934 14.224 2.87 14.177 2.823C14.13 2.776 14.066 2.75 14 2.75H3C2.934 2.75 2.87 2.776 2.823 2.823C2.776 2.87 2.75 2.934 2.75 3V21C2.75 21.066 2.776 21.13 2.823 21.177C2.87 21.224 2.934 21.25 3 21.25H14.25V3Z",
    fill: "#2667B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 15.5V22C11.75 22.414 11.414 22.75 11 22.75H6C5.586 22.75 5.25 22.414 5.25 22V15.5C5.25 15.168 5.382 14.851 5.616 14.616C5.851 14.382 6.169 14.25 6.5 14.25H10.5C10.831 14.25 11.149 14.382 11.384 14.616C11.618 14.851 11.75 15.168 11.75 15.5ZM6.75 15.75V21.25H10.25V15.75H6.75Z",
    fill: "#2667B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 9V21C22.75 21.967 21.966 22.75 21 22.75H15C14.586 22.75 14.25 22.414 14.25 22V8C14.25 7.586 14.586 7.25 15 7.25H21C21.966 7.25 22.75 8.033 22.75 9ZM21.25 9C21.25 8.862 21.138 8.75 21 8.75H15.75V21.25H21C21.138 21.25 21.25 21.138 21.25 21V9Z",
    fill: "#2667B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 4.5H6.25V6H4.75V4.5Z",
    fill: "#2667B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 8H6.25V9.5H4.75V8Z",
    fill: "#2667B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 11.5H6.25V13H4.75V11.5Z",
    fill: "#2667B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 4.5H9.25V6H7.75V4.5Z",
    fill: "#2667B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 8H9.25V9.5H7.75V8Z",
    fill: "#2667B0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 11.5H9.25V13H7.75V11.5Z",
    fill: "#2667B0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 4.5H12.25V6H10.75V4.5Z",
    fill: "#2667B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 10.75H19.25V12.25H17.75V10.75Z",
    fill: "#2667B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 14.25H19.25V15.75H17.75V14.25Z",
    fill: "#2667B0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 17.75H19.25V19.25H17.75V17.75Z",
    fill: "#2667B0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 8H12.25V9.5H10.75V8Z",
    fill: "#2667B0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 11.5H12.25V13H10.75V11.5Z",
    fill: "#2667B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIconBlue);
export default __webpack_public_path__ + "static/media/company_icon_blue.602e7cf0d972c979c35031c974f73f21.svg";
export { ForwardRef as ReactComponent };